import { useManagementSubscriptionContext } from "./Context";

const Step1 = () => {
  const { totalEntries, basePrice, subscriptionPlan, onNext, onCancelSubscriptionModal } =
    useManagementSubscriptionContext();
  return (
    <div data-name={"modal-step-1"} className={"h-full grow flex flex-col"}>
      <div className={"scroll-wrapper grow relative mb-4 lg:mb-1.5"}>
        <div className={"max-lg:absolute max-lg:inset-0 size-full max-lg:overflow-y-auto"}>
          <div className={"mb-6 lg:mb-8"}>
            <div
              className={
                "text-dark-1 text-center font-jost text-xl font-semibold leading-6.5 mb-1.5 lg:mb-3 lg:text-[28px] lg:leading-8"
              }>
              If you cancel you’ll lose access to
            </div>
            <div
              className={
                "w-full max-lg:max-w-[200px] mx-auto text-dark-1 text-center font-jost text-base font-medium leading-5.5 lg:text-xl lg:font-bold lg:leading-6.5"
              }>
              {totalEntries} entries <span className={"text-gray-1"}>monthly</span>
              <br className={"lg:hidden"} />
              <span className={"bg-primary px-2 text-white"}>
                <span className={"line-through"}>{basePrice}</span> value
              </span>{" "}
              for just £{subscriptionPlan.amount / 100}*
            </div>
          </div>

          <div className={"flex flex-col justify-center mb-4 lg:mb-7.5"}>
            <div
              className={
                "flex flex-col lg:flex-row items-center gap-2 lg:gap-8 bg-gray-4 px-[14px] py-4 lg:px-4 lg:py-3 rounded-lg lg:justify-center"
              }>
              <div className={"w-full lg:w-auto flex items-center gap-4 lg:gap-8"}>
                <div className={"flex gap-3 p-2 w-full lg:w-auto"}>
                  <img
                    src="/assets/images/subscriptions/trophy.webp"
                    alt="Trophy"
                    width={32}
                    height={32}
                    className={"size-8 aspect-square shrink-0"}
                  />
                  <div className={"grow flex flex-col gap-1"}>
                    <div className={"text-primary font-jost text-lg font-semibold leading-6"}>21</div>
                    <div className={"text-gray-1 font-jost text-xs font-medium leading-3 whitespace-nowrap"}>
                      Monthly
                      <br /> competitions
                    </div>
                  </div>
                </div>
                <div className={"w-px h-8 bg-black/8 lg:border-2 lg:bg-transparent lg:border-black/8 lg:rounded"}></div>
                <div className={"flex gap-3 p-2 w-full lg:w-auto"}>
                  <img
                    src="/assets/images/subscriptions/prizes.webp"
                    alt="Prizes"
                    width={32}
                    height={32}
                    className={"size-8 aspect-square shrink-0"}
                  />
                  <div className={"grow flex flex-col gap-1"}>
                    <div className={"text-primary font-jost text-lg font-semibold leading-6"}>£2.3M</div>
                    <div className={"text-gray-1 font-jost text-xs font-medium leading-3 whitespace-nowrap"}>
                      Available
                      <br />
                      in prizes
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  "w-[280px] h-px lg:w-px lg:h-8 bg-black/8 lg:border-2 lg:bg-transparent lg:border-black/8 lg:rounded"
                }></div>
              <div className={"w-full lg:w-auto flex items-center gap-4 lg:gap-8"}>
                <div className={"flex gap-3 p-2 w-full lg:w-auto"}>
                  <img
                    src="/assets/images/subscriptions/savings.webp"
                    alt="Savings"
                    width={32}
                    height={32}
                    className={"size-8 aspect-square shrink-0"}
                  />
                  <div className={"grow flex flex-col gap-1"}>
                    <div className={"text-primary font-jost text-lg font-semibold leading-6 flex flex-col"}>
                      <span className={"text-[11px] leading-normal"}>up to</span>
                      <span>370%*</span>
                    </div>
                    <div className={"text-gray-1 font-jost text-xs font-medium leading-3 whitespace-nowrap"}>
                      Value on
                      <br />
                      your money
                    </div>
                  </div>
                </div>
                <div className={"w-px h-8 bg-black/8 lg:border-2 lg:bg-transparent lg:border-black/8 lg:rounded"}></div>
                <div className={"flex gap-3 p-2 w-full lg:w-auto"}>
                  <img
                    src="/assets/images/subscriptions/money.webp"
                    alt="Money"
                    width={32}
                    height={32}
                    className={"size-8 aspect-square shrink-0"}
                  />
                  <div className={"grow flex flex-col gap-1"}>
                    <div className={"text-primary font-jost text-lg font-semibold leading-6 flex flex-col"}>
                      <span className={"text-[11px] leading-normal"}>up to</span>
                      <span>£117*</span>
                    </div>
                    <div className={"text-gray-1 font-jost text-xs font-medium leading-3 whitespace-nowrap"}>
                      saved vs. direct
                      <br /> purchases
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={"hidden lg:block mb-2"}>
            <div className={"text-gray-1 text-center font-jost text-xl font-normal leading-6.5 mb-6"}>
              BOTB Pass. 21 monthly competitions with amazing prizes
            </div>
            <div className={"grid grid-cols-2 gap-4"}>
              <div className={"flex items-center gap-3 w-full border border-black/8 rounded-lg px-2"}>
                <img
                  src={"/assets/images/subscriptions/house.webp"}
                  alt={"Prize 1"}
                  width={88}
                  height={88}
                  className={"size-[88px] aspect-square shrink-0"}
                />
                <div className={"flex flex-col items-start gap-1 py-2"}>
                  <div className={"text-gray-1 font-jost text-base font-medium leading-6.5"}>
                    <span className={"text-primary text-xl font-bold"}>1x</span> Dream House
                  </div>
                  <div className={"text-gray-1 font-jost text-[13px] font-normal leading-4.5"}>
                    £500K+ properties including luxury homes, apartments, and country estates
                  </div>
                </div>
              </div>
              <div className={"flex items-center gap-3 w-full border border-black/8 rounded-lg px-2"}>
                <img
                  src={"/assets/images/subscriptions/lifestyle.webp"}
                  alt={"Prize 2"}
                  width={88}
                  height={88}
                  className={"size-[88px] aspect-square shrink-0"}
                />
                <div className={"flex flex-col items-start gap-1 py-2"}>
                  <div className={"text-gray-1 font-jost text-base font-medium leading-6.5"}>
                    <span className={"text-primary text-xl font-bold"}>4x</span> Pick Your Prize
                  </div>
                  <div className={"text-gray-1 font-jost text-[13px] font-normal leading-4.5"}>
                    Luxury holidays, technology, experiences, and premium goods in our Lifestyle Competitions
                  </div>
                </div>
              </div>
              <div className={"flex items-center gap-3 w-full border border-black/8 rounded-lg px-2"}>
                <img
                  src={"/assets/images/subscriptions/cars.webp"}
                  alt={"Prize 3"}
                  width={88}
                  height={88}
                  className={"size-[88px] aspect-square shrink-0"}
                />
                <div className={"flex flex-col items-start gap-1 py-2"}>
                  <div className={"text-gray-1 font-jost text-base font-medium leading-6.5"}>
                    <span className={"text-primary text-xl font-bold"}>10x</span> Cars
                  </div>
                  <div className={"text-gray-1 font-jost text-[13px] font-normal leading-4.5"}>
                    Supercars, luxury vehicles, classic cars, and electric vehicles in our Dream Car and prize draw
                    comps
                  </div>
                </div>
              </div>
              <div className={"flex items-center gap-3 w-full border border-black/8 rounded-lg px-2"}>
                <img
                  src={"/assets/images/subscriptions/instant-wins.webp"}
                  alt={"Prize 4"}
                  width={88}
                  height={88}
                  className={"size-[88px] aspect-square shrink-0"}
                />
                <div className={"flex flex-col items-start gap-1 py-2"}>
                  <div className={"text-gray-1 font-jost text-base font-medium leading-6.5"}>
                    <span className={"text-primary text-xl font-bold"}>6x</span> Instant Wins
                  </div>
                  <div className={"text-gray-1 font-jost text-[13px] font-normal leading-4.5"}>
                    Daily opportunities for cash, gadgets, vouchers, and surprise prizes
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              "text-gray-5 font-jost text-[11px] font-normal leading-[14px] mb-6 lg:text-[13px] lg:leading-4.5 lg:mb-0"
            }>
            *Savings shown relates to tickets in BOTB Pass vs. buying tickets separately
          </div>
        </div>
      </div>
      <div className={"flex gap-2 lg:justify-end"}>
        <button onClick={onNext} className={"theme-btn theme-btn-md uppercase max-lg:w-full text-primary"}>
          Cancel anyway
        </button>
        <button
          onClick={onCancelSubscriptionModal}
          className={"theme-btn theme-btn-primary theme-btn-md uppercase max-lg:w-full"}>
          Keep subscription
        </button>
      </div>
    </div>
  );
};

export default Step1;
